import { createFileRoute } from "@tanstack/react-router";

import { TransferFormPage } from "../../../../features/inventory/transfer-form-page";

export const Route = createFileRoute("/_app/inventory/transfers/new")({ component: TransferFormPage });
